import type {Result, UseCase} from 'framework';
import type {OnboardingStatusRepository} from '../ports/onboarding-status.repository';

export class CompleteOnboarding implements UseCase<[], void> {
  constructor(private readonly onboardingStatusRepository: OnboardingStatusRepository) {}

  execute(): Promise<Result<void>> {
    return this.onboardingStatusRepository.markComplete();
  }
}
